(function(){
  angular
    .module('EdxCommonModule')
    .value('edxTypeOfLearning', {
      EARLY_SENSE_MAKING: 'EarlySenseMaking',
      LOOKING_FOR_STRUCTURE: 'LookingForStructure',
      FLUENTLY_USING_STRUCTURES: 'FluentlyUsingStructures'
    });
})();